import { render, staticRenderFns } from "./ModalFiltros.vue?vue&type=template&id=7bd12b16&"
import script from "./ModalFiltros.vue?vue&type=script&lang=js&"
export * from "./ModalFiltros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports